import React, { useCallback } from "react";
import "../Header/Header.css";
import { FaArrowUp } from "react-icons/fa6";
import { Tooltip } from "antd";
import { motion } from "framer-motion";

const Footer = () => {
  const scrollToTop = useCallback(() => {
    window.scrollTo({
      top: 0,
      behavior: "smooth",
    });
  }, []);

  return (
    <div className="text-[14px] md:text-xl lg:text-[17px] 2xl:text-xl leading-7 md:leading-8 lg:leading-7 2xl:leading-10">
      <div className="mt-0 bg-[#1A1919] rounded-2xl rounded-b-none py-[2%] px-[3%]">
        <div className="grid grid-cols-1 lg:grid-cols-2 justify-between">
          <div>
            <p className="heading text-5xl md:text-6xl lg:text-7xl mt-10 lg:mt-10  text-white text-center lg:text-left uppercase">
              let’s work <br />
              together
            </p>
          </div>
          <div className="grid grid-cols-1 lg:grid-cols-2 gap-[10%] text-center items-center mt-5 lg:mt-10">
            <div className="border border-[#595757] mx-[20%] lg:mx-0 p-[5%] lg:py-[10%] lg:px-[5%] rounded-2xl text-white">
              <p>Want to discuss through message?</p>
              <div className="flex justify-center mt-[8%] lg:mt-[5%]">
                {/* <div className="joint_btn arrow_btn-wrapper bg-[#F56E0F] py-[0.2%] px-[2.5%] lg:px-[3.5%] rounded-full text-[#1A1919] cursor-pointer">
                  Whatsapp
                </div> */}
                    <a
                  href="https://wa.me/919664570369"
                  target="_blank"
                  rel="noopener noreferrer"
                  className="joint_btn arrow_btn-wrapper bg-[#F56E0F] py-1 px-[2.5%] lg:px-[3.5%] rounded-full text-base text-[#1A1919] cursor-pointer inline-block"
                >
                  Whatsapp
                </a>
                
                <div
                  style={{ "--clr": "#F56E0F" }}
                  className="arrow_btn cursor-pointer"
                >
                  <span className="arrow_btn__icon-wrapper">
                    <svg
                      width="10"
                      className="arrow_btn__icon-svg"
                      xmlns="http://www.w3.org/2000/svg"
                      fill="none"
                      viewBox="0 0 14 15"
                    >
                      <path
                        fill="currentColor"
                        d="M13.376 11.552l-.264-10.44-10.44-.24.024 2.28 6.96-.048L.2 12.56l1.488 1.488 9.432-9.432-.048 6.912 2.304.024z"
                      ></path>
                    </svg>
                    <svg
                      className="arrow_btn__icon-svg arrow_btn__icon-svg--copy"
                      xmlns="http://www.w3.org/2000/svg"
                      width="10"
                      fill="none"
                      viewBox="0 0 14 15"
                    >
                      <path
                        fill="currentColor"
                        d="M13.376 11.552l-.264-10.44-10.44-.24.024 2.28 6.96-.048L.2 12.56l1.488 1.488 9.432-9.432-.048 6.912 2.304.024z"
                      ></path>
                    </svg>
                  </span>
                </div>
              </div>
            </div>

            <div className="border border-[#595757] mx-[20%] lg:mx-0 p-[5%] lg:py-[10%] lg:px-[5%] rounded-2xl text-white">
              <p>Or discuss through online meeting?</p>
              <div className="flex justify-center mt-[8%] lg:mt-[5%]">
                <div className="joint_btn arrow_btn-wrapper bg-[#F56E0F] text-base py-1  px-[2.5%] lg:px-[3.5%] rounded-full text-[#1A1919] cursor-pointer">
                  Set meeting
                </div>
                <div
                  style={{ "--clr": "#F56E0F" }}
                  className="arrow_btn cursor-pointer"
                >
                  <span className="arrow_btn__icon-wrapper">
                    <svg
                      width="10"
                      className="arrow_btn__icon-svg"
                      xmlns="http://www.w3.org/2000/svg"
                      fill="none"
                      viewBox="0 0 14 15"
                    >
                      <path
                        fill="currentColor"
                        d="M13.376 11.552l-.264-10.44-10.44-.24.024 2.28 6.96-.048L.2 12.56l1.488 1.488 9.432-9.432-.048 6.912 2.304.024z"
                      ></path>
                    </svg>
                    <svg
                      className="arrow_btn__icon-svg arrow_btn__icon-svg--copy"
                      xmlns="http://www.w3.org/2000/svg"
                      width="10"
                      fill="none"
                      viewBox="0 0 14 15"
                    >
                      <path
                        fill="currentColor"
                        d="M13.376 11.552l-.264-10.44-10.44-.24.024 2.28 6.96-.048L.2 12.56l1.488 1.488 9.432-9.432-.048 6.912 2.304.024z"
                      ></path>
                    </svg>
                  </span>
                </div>
              </div>
            </div>
          </div>
        </div>

        <hr className="border border-[#595757] my-[15%] lg:my-[5%]" />

        <div>
          <div className="grid grid-cols-1 lg:grid-cols-2 items-center">
            <div className="text-white">
              {/* <p>
                404, Pride Empire, Race Course,
                <br />
                Sadar, Rajkot - <br />
                360001 (Near Big Bite)
              </p> */}
              <a
                href="https://www.google.com/maps/search/?api=1&query=404+Pride+Empire+Race+Course+Sadar+Rajkot+360001"
                target="_blank"
                rel="noopener noreferrer"
                className="hover:underline"
              >
                <p>
                  404, Pride Empire, 
                  <br />
                 Race Course, Sadar, <br />
                 Rajkot - 360005
                </p>
              </a>
            </div>
            <div className="flex lg:justify-end mt-[5%] lg:mt-0">
              <div className="card_socialFooter">
                <a
                  href="https://www.instagram.com/open.studios.co/"
                  className="socialContainer_socialFooter containerOne_socialFooter"
                >
                  <svg
                    className="socialSvg_socialFooter instagramSvg_socialFooter"
                    viewBox="0 0 16 16"
                  >
                    <path d="M8 0C5.829 0 5.556.01 4.703.048 3.85.088 3.269.222 2.76.42a3.917 3.917 0 0 0-1.417.923A3.927 3.927 0 0 0 .42 2.76C.222 3.268.087 3.85.048 4.7.01 5.555 0 5.827 0 8.001c0 2.172.01 2.444.048 3.297.04.852.174 1.433.372 1.942.205.526.478.972.923 1.417.444.445.89.719 1.416.923.51.198 1.09.333 1.942.372C5.555 15.99 5.827 16 8 16s2.444-.01 3.298-.048c.851-.04 1.434-.174 1.943-.372a3.916 3.916 0 0 0 1.416-.923c.445-.445.718-.891.923-1.417.197-.509.332-1.09.372-1.942C15.99 10.445 16 10.173 16 8s-.01-2.445-.048-3.299c-.04-.851-.175-1.433-.372-1.941a3.926 3.926 0 0 0-.923-1.417A3.911 3.911 0 0 0 13.24.42c-.51-.198-1.092-.333-1.943-.372C10.443.01 10.172 0 7.998 0h.003zm-.717 1.442h.718c2.136 0 2.389.007 3.232.046.78.035 1.204.166 1.486.275.373.145.64.319.92.599.28.28.453.546.598.92.11.281.24.705.275 1.485.039.843.047 1.096.047 3.231s-.008 2.389-.047 3.232c-.035.78-.166 1.203-.275 1.485a2.47 2.47 0 0 1-.599.919c-.28.28-.546.453-.92.598-.28.11-.704.24-1.485.276-.843.038-1.096.047-3.232.047s-2.39-.009-3.233-.047c-.78-.036-1.203-.166-1.485-.276a2.478 2.478 0 0 1-.92-.598 2.48 2.48 0 0 1-.6-.92c-.109-.281-.24-.705-.275-1.485-.038-.843-.046-1.096-.046-3.233 0-2.136.008-2.388.046-3.231.036-.78.166-1.204.276-1.486.145-.373.319-.64.599-.92.28-.28.546-.453.92-.598.282-.11.705-.24 1.485-.276.738-.034 1.024-.044 2.515-.045v.002zm4.988 1.328a.96.96 0 1 0 0 1.92.96.96 0 0 0 0-1.92zm-4.27 1.122a4.109 4.109 0 1 0 0 8.217 4.109 4.109 0 0 0 0-8.217zm0 1.441a2.667 2.667 0 1 1 0 5.334 2.667 2.667 0 0 1 0-5.334z"></path>
                  </svg>
                </a>

                <a
                  className="socialContainer_socialFooter containerTwo_socialFooter"
                  href="https://www.linkedin.com/company/open-studioss/"
                >
                  <svg
                    viewBox="0 0 448 512"
                    className="socialSvg_socialFooter linkdinSvg_socialFooter"
                  >
                    <path d="M100.28 448H7.4V148.9h92.88zM53.79 108.1C24.09 108.1 0 83.5 0 53.8a53.79 53.79 0 0 1 107.58 0c0 29.7-24.1 54.3-53.79 54.3zM447.9 448h-92.68V302.4c0-34.7-.7-79.2-48.29-79.2-48.29 0-55.69 37.7-55.69 76.7V448h-92.78V148.9h89.08v40.8h1.3c12.4-23.5 42.69-48.3 87.88-48.3 94 0 111.28 61.9 111.28 142.3V448z"></path>
                  </svg>
                </a>

                <a
                  href="https://wa.me/919664570369"
                  className="socialContainer_socialFooter containerFour_socialFooter"
                >
                  <svg
                    className="socialSvg_socialFooter whatsappSvg_socialFooter"
                    viewBox="0 0 16 16"
                  >
                    <path d="M13.601 2.326A7.854 7.854 0 0 0 7.994 0C3.627 0 .068 3.558.064 7.926c0 1.399.366 2.76 1.057 3.965L0 16l4.204-1.102a7.933 7.933 0 0 0 3.79.965h.004c4.368 0 7.926-3.558 7.93-7.93A7.898 7.898 0 0 0 13.6 2.326zM7.994 14.521a6.573 6.573 0 0 1-3.356-.92l-.24-.144-2.494.654.666-2.433-.156-.251a6.56 6.56 0 0 1-1.007-3.505c0-3.626 2.957-6.584 6.591-6.584a6.56 6.56 0 0 1 4.66 1.931 6.557 6.557 0 0 1 1.928 4.66c-.004 3.639-2.961 6.592-6.592 6.592zm3.615-4.934c-.197-.099-1.17-.578-1.353-.646-.182-.065-.315-.099-.445.099-.133.197-.513.646-.627.775-.114.133-.232.148-.43.05-.197-.1-.836-.308-1.592-.985-.59-.525-.985-1.175-1.103-1.372-.114-.198-.011-.304.088-.403.087-.088.197-.232.296-.346.1-.114.133-.198.198-.33.065-.134.034-.248-.015-.347-.05-.099-.445-1.076-.612-1.47-.16-.389-.323-.335-.445-.34-.114-.007-.247-.007-.38-.007a.729.729 0 0 0-.529.247c-.182.198-.691.677-.691 1.654 0 .977.71 1.916.81 2.049.098.133 1.394 2.132 3.383 2.992.47.205.84.326 1.129.418.475.152.904.129 1.246.08.38-.058 1.171-.48 1.338-.943.164-.464.164-.86.114-.943-.049-.084-.182-.133-.38-.232z"></path>
                  </svg>
                </a>

                {/* <a
                  href="/"
                  className="socialContainer_socialFooter containerThree_socialFooter"
                >
                  <div>
                    <svg
                      className="socialSvg_socialFooter tiktokSvg_socialFooter largeIcon_socialFooter"
                      width="44px"
                      height="44px"
                      viewBox="0 4 45 35"
                      version="1.1"
                      xmlns="http://www.w3.org/2000/svg"
                    >
                      <title>Facebook</title>
                      <g
                        id="Icon/Social/facebook-black"
                        stroke="none"
                        stroke-width="1"
                        fill="none"
                        fill-rule="evenodd"
                      >
                        <path
                          d="M30.0793333,40 L30.0793333,27.608 L34.239,27.608 L34.8616667,22.7783333 L30.0793333,22.7783333 L30.0793333,19.695 C30.0793333,18.2966667 30.4676667,17.344 32.4726667,17.344 L35.0303333,17.3426667 L35.0303333,13.0233333 C34.5876667,12.9646667 33.0696667,12.833 31.3036667,12.833 C27.6163333,12.833 25.0923333,15.0836667 25.0923333,19.2166667 L25.0923333,22.7783333 L20.922,22.7783333 L20.922,27.608 L25.0923333,27.608 L25.0923333,40 L30.0793333,40 Z M9.766,40 C8.79033333,40 8,39.209 8,38.234 L8,9.766 C8,8.79033333 8.79033333,8 9.766,8 L38.2336667,8 C39.209,8 40,8.79033333 40,9.766 L40,38.234 C40,39.209 39.209,40 38.2336667,40 L9.766,40 Z"
                          id="Shape"
                          fill="#FFFFFF"
                        ></path>
                      </g>
                    </svg>
                  </div>
                </a> */}
              </div>
            </div>
          </div>
          {/* <div className="flex justify-center m-[10%]">
            <img src="../assets/openStudios_whiteLogo.webp" alt="Logo" />
          </div> */}
          <motion.div 
            className="flex justify-center m-[10%]"
            initial={{ scale: 1 }}
            whileInView={{ scale: 1.1 }} 
            transition={{
              duration: 2.2,  
              ease: "easeOut",
            }}  
            viewport={{ once: true }}  
          >
            <img
              src="../assets/openStudios_whiteLogo.webp"
              alt="Logo"
              className="block mx-auto"
            />
          </motion.div>

        </div>

        <div className="flex items-center gap-[2%] lg:gap-[5%] lg:w-[80%] text-white"> 
          <a
            href="https://inittechnology.co"
            target="_blank"
            rel="noopener noreferrer"
          >
            <p className="hover:underline">© 2024 INIT TECHNOLOGY</p>
          </a>

          <a href="/WorkPage"><p className="hover:underline">Our works</p></a>
          <a href="/"><p className="hover:underline">Privacy policy</p></a>
          <a href="/"><p className="hover:underline">Cookie policy</p></a>

          <Tooltip title="Back to Top">
            <button
              className="absolute right-3 lg:right-[3%] 2xl:right-[5%] hover:underline group"
              onClick={scrollToTop}
              name="scrollToTop_btn"
            >
              <span className="flex items-center text-white">
                <p className="hidden lg:block">Back to top</p>
                <FaArrowUp className="text-[1.2em] ml-2 group-hover:scale-y-150 lg:group-hover:scale-110 transition-transform duration-300 hover:text-[#F56E0F] lg:hover:text-white" />
              </span>
            </button>
          </Tooltip>
        </div>
      </div>
    </div>
  );
};

export default Footer;
